<!-- bs-receipt.component -->
<div class="receipt">
    <h2 class="receipt__heading">TILLYKKE! Du er med i lodtrækningen fra {{
        bsSalesDate | date :
        "MMMM"
        }}.</h2>
    <div class="receipt__content">
        <div class="receipt__section">
            <div class="receipt__row">
                <div>
                    <h3 class="receipt__sub-heading">Kvittering</h3>
                    <span class="receipt__sub-heading-email">Kvitteringen er sendt til din e-mail</span>
                </div>
                <div class="receipt__row-date">
                    {{ dateOfPurchase | date: 'dd. MMM yyyy' }}
                </div>
            </div>
            <div class="receipt__row receipt__row--border-top">
                <div>
                    {{ classCount === 6 ? "Halvårlig" : "Månedlig" }} betaling fra {{ bsSalesDate | date : "MMMM" }}
                </div>

                <div class="receipt__row-price">
                    {{ (classCount === 6 ? priceTotal : totalPriceIncludingFees) | money }}{{
                    classCount === 6
                    ? " /halvår" : " /md"
                    }}
                    <span class="accordion__toggle {{accordionIsOpen ? 'accordion__toggle--open' : ''}}"
                          (click)="toggleAccordion()"></span>
                </div>
            </div>
        </div>

        <div class="receipt__section accordion__content {{accordionIsOpen ? 'accordion__content--open' : ''}}">
            <app-orderline-list [checkoutState]="checkoutState" [navigate-checkout]="false"
                                [showFees]="true" [show-per-month]="classCount !== 6" [price-factor]="classCount"
                                [isBasketPage]="false" [isCheckout]="false">

            </app-orderline-list>
        </div>
    </div>
</div>

<app-gapfunding-upsell
        *ngIf="canOfferGapFunding"
        [pricePrMonth]="pricePrMonth"
        [onConfirmCreateGapFund]="onConfirmCreateGapFund"
        [dibsSalesDate]="dibsSalesDate">
</app-gapfunding-upsell>
<!-- /bs-receipt.component -->
